import { render, staticRenderFns } from "./adminDashboardView.vue?vue&type=template&id=1bc0e7e8&scoped=true"
import script from "./adminDashboardView.vue?vue&type=script&lang=js"
export * from "./adminDashboardView.vue?vue&type=script&lang=js"
import style0 from "./adminDashboardView.vue?vue&type=style&index=0&id=1bc0e7e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc0e7e8",
  null
  
)

export default component.exports